"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCharacterLimitText = void 0;
var getCharacterLimitText = function (_a) {
    var minLength = _a.minLength, maxLength = _a.maxLength;
    if (maxLength == null && minLength == null) {
        return '';
    }
    if (maxLength == null) {
        return minLength + "\u6587\u5B57\u4EE5\u4E0A";
    }
    if (minLength == null) {
        return maxLength + "\u6587\u5B57\u4EE5\u4E0B";
    }
    if (maxLength === minLength) {
        return minLength + "\u6587\u5B57";
    }
    return minLength + "\u301C" + maxLength + "\u6587\u5B57";
};
exports.getCharacterLimitText = getCharacterLimitText;
